import React from 'react';
import { useQuery } from 'react-query';
import { useMount } from 'react-use';

import { useRedirectForbidden } from '@hooks';

import * as utils from './utils';

// If you are going to use refetetchOnMount: true please read comments in src\constants\reactQuery.js
export default (queryKey, queryFn, { parseApiError = utils.parseApiError, ...queryOptions }) => {
  const [error, setError] = React.useState(null);
  const redirectForbidden = useRedirectForbidden();

  const queryResult = useQuery(queryKey, queryFn, {
    ...queryOptions,
    onError: async (e, ...args) => {
      if (e.response?.status === 403) redirectForbidden();

      const parsedError = await parseApiError({ error: e });
      setError(parsedError);
      // eslint-disable-next-line no-unused-expressions
      return queryOptions.onError?.(parsedError, ...args);
    },
    onSuccess: (...args) => {
      setError(null);
      // eslint-disable-next-line no-unused-expressions
      return queryOptions.onSuccess?.(...args);
    },
  });

  useMount(async () => {
    /**
     * If query was already fetched before and it is in error state
     * make sure that new query instance has same parsed error passed
     */
    if (queryResult.error) {
      const parsedError = await parseApiError({ error: queryResult.error });
      setError(parsedError);
    }
  });

  return {
    ...queryResult,
    originalError: queryResult.error,
    error,
  };
};
